var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3 7.4a.8.8 0 0 0-1.25.65v7.9a.8.8 0 0 0 1.26.65l5.6-3.95a.8.8 0 0 0 0-1.3l-5.6-3.95Zm.35 7V9.6l3.42 2.4-3.42 2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.14 6.16a4.24 4.24 0 0 0-4.17-4.28c-5.44-.24-8.5-.24-13.93 0A4.25 4.25 0 0 0 .87 6.17c-.23 3.1-.22 8.54 0 11.66a4.25 4.25 0 0 0 4.16 4.29c5.45.24 8.48.24 13.93 0a4.26 4.26 0 0 0 4.17-4.3c.22-3.1.23-8.54 0-11.66ZM5.09 3.48a133.08 133.08 0 0 1 13.86 0 2.65 2.65 0 0 1 2.59 2.76 101.51 101.51 0 0 1 0 11.56 2.66 2.66 0 0 1-2.63 2.72 132 132 0 0 1-13.86 0 2.66 2.66 0 0 1-2.59-2.78A99.28 99.28 0 0 1 2.47 6.2 2.65 2.65 0 0 1 5.1 3.48Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLine);
export default __webpack_public_path__ + "static/media/youtube_line.54618e7b5206f0d102b8d04059b1b071.svg";
export { ForwardRef as ReactComponent };